import React from "react";
import {AlertRhombusIcon} from "../icons/icons/AlertRhombusIcon";
import {themeColors} from "../../styles/theme";
import './alertlabel.scss';


const AlertLabel = ({text}: { text: string; }) => {
    return (
        <div className="alertlabel">
            <AlertRhombusIcon
                color={themeColors.invalidColor1}
            />
            <span
                style={{color: themeColors.invalidColor1}}
            >
                {text}
            </span>
        </div>
    )
}

export default AlertLabel;